import { useMediaQuery } from '@mui/material';

interface ScreenSize {
  isNotMobile: boolean;
  isNotTablet: boolean;
  isNotDesktop: boolean;
  isNotLargeDesktop: boolean;
  isNotExtraLarge: boolean;
}
export enum Breakpoints {
  Mobile = 480,
  Tablet = 768,
  Desktop = 1024,
  LargeDesktop = 1440,
  ExtraLarge = 4000,
}

export const MediaBreakpoints = {
  mobile: `(max-width: ${Breakpoints.Mobile}px)`,
  tablet: `(max-width: ${Breakpoints.Tablet}px)`,
  desktop: `(max-width: ${Breakpoints.Desktop}px)`,
  largeDesktop: `(max-width: ${Breakpoints.LargeDesktop}px)`,
  extraLarge: `(max-width: ${Breakpoints.ExtraLarge}px)`,
};

const useScreenSize = (): ScreenSize => {
  const isNotMobile = useMediaQuery(MediaBreakpoints.mobile);
  const isNotTablet = useMediaQuery(MediaBreakpoints.tablet);
  const isNotDesktop = useMediaQuery(MediaBreakpoints.desktop);
  const isNotLargeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);
  const isNotExtraLarge = useMediaQuery(MediaBreakpoints.extraLarge);

  return { isNotMobile, isNotTablet, isNotDesktop, isNotLargeDesktop, isNotExtraLarge };
};

export default useScreenSize;
